module.exports = __webpack_public_path__ + "static/media/quiz_12a.5cccf3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/quiz_12a.jpg
// module id = 689
// module chunks = 0